// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Z7oeG","image":"Header_image__1GWvG","name":"Header_name__u6eI8","info":"Header_info__2jn2d","infoRow":"Header_infoRow__COMNN"};